import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Table } from 'react-bootstrap'
import { useStateValue } from '../../state'
import ButterToast, { Cinnamon } from 'butter-toast'
import { client } from '@Utils'
import { LoadingSpinner } from '../../../components'
import { GradeLogListView } from '../grade_logs/GradeLogListView'

export const ResourceLink = ({ match }) => {
  const [currentState, dispatch] = useStateValue()
  const [isLoading, setIsLoading] = useState(true)
  const [isWaiting, setIsWaiting] = useState(false)
  const [showMetaInfo, setShowMetaInfo] = useState(false)
  const [responses, setResponses] = useState([])
  const [resourceLinkObj, setResourceLinkObj] = useState(null)

  const missingGradeStyle = {
    backgroundColor: '#f8d7da',
    color: '#842029',
  }

  const postSingleScore = async (resourceLinkId, userId) => {
    setIsLoading(true)

    try {
      await client.get(
        `/account/admin_lti13.postResultForLineItemAndUser/-/${resourceLinkId}/${userId}/`
      )

      dispatch({ type: 'updateMessage', message: null })
      dispatch({ type: 'reload', reload: !currentState.reloadSwitch })
    } catch (err) {
      console.error(err)
      dispatch({ type: 'updateMessage', message: err.response.data.error })
    }
  }

  const postScores = async () => {
    setIsWaiting(true)
    setIsLoading(true)

    try {
      let resp = await client.get(
        `/account/admin_lti13.postResultsForLineItem/-/${match.params.resourceLinkId}/`
      )
      setResponses(resp.data.responses)

      dispatch({ type: 'updateMessage', message: null })
      dispatch({
        type: 'updateLineItemResults',
        lineItemResults: resp.data.results,
      })
    } catch (err) {
      console.error(err)
      dispatch({ type: 'updateMessage', message: err.response.data.error })
    } finally {
      setIsWaiting(false)
      setIsLoading(false)
    }
  }

  useEffect(() => {
    const getLineItemObject = async () => {
      try {
        let resp = await client.get(
          `/account/admin_lti13.getResourceLinks/-/${match.params.contextCourseId}/${match.params.resourceLinkId}/`
        )
        setResourceLinkObj(resp.data.resourceLinks[0])
      } catch (err) {
        console.log(err)
        dispatch({
          type: 'updateMessage',
          message: 'An error occurred trying to get the ResourceLink object.',
        })
      }
    }
    getLineItemObject()
  }, [])

  useEffect(() => {
    const getLineItemResults = async () => {
      try {
        let resp = await client.get(
          `/account/admin_lti13.getResultsForLineItem/-/${match.params.resourceLinkId}/`
        )
        dispatch({ type: 'updateMessage', message: null })
        dispatch({
          type: 'updateLineItemResults',
          lineItemResults: resp.data.lineItemResults,
        })
      } catch (err) {
        dispatch({ type: 'updateLineItemResults', lineItemResults: [] })
        if (err.response) {
          if (err.response.status >= 205) {
            dispatch({
              type: 'updateMessage',
              message: err.response.statusText,
            })
            ButterToast.raise({
              content: (
                <Cinnamon.Crisp
                  title={err.response.statusText}
                  content={err.response.data.error}
                  scheme={Cinnamon.Crisp.SCHEME_RED}
                  icon={<i className="far fa-thumbs-down fa-3x" />}
                />
              ),
            })
          } else {
            dispatch({
              type: 'updateMessage',
              message: err.response.data.error,
            })
          }
        } else {
          dispatch({ type: 'updateMessage', message: err })
        }
      } finally {
        setIsLoading(false)
      }
    }
    getLineItemResults()
  }, [currentState.reloadSwitch])

  return (
    <React.Fragment>
      <div className="mb-2 go-back-button-left-align">
        <Link
          className="btn btn-default btn-myed btn-default-myed btn-sm-myed mr-4"
          to={`/account/admin_lti13/-/platforms/${match.params.lmsCode}/issuers/${match.params.issuerId}/clients/${match.params.clientId}/deployments/${match.params.deploymentId}/contexts/${match.params.contextId}/contextCourses/${match.params.contextCourseId}`}
        >
          <div className="far fa-arrow-circle-left fa-fw mr-2" /> Go Back
        </Link>
      </div>
      <div className="activity-page-title-left-align" id="activity-page-title">
        {resourceLinkObj && (
          <ActivityPageTitle resourceLinkObj={resourceLinkObj} />
        )}
      </div>
      <div className="card-myed">
        <h3>
          More Info{' '}
          <i
            className={`far ${
              showMetaInfo ? 'fa-chevron-down' : 'fa-chevron-right'
            } mr-2 color_teal fa-fw show-meta-info`}
            onClick={() => {
              setShowMetaInfo(!showMetaInfo)
            }}
          />
        </h3>
        {showMetaInfo && resourceLinkObj && (
          <ResourceLinkInfo resourceLinkObj={resourceLinkObj} />
        )}
      </div>
      <div className="card-myed">
        <h3>LMS Call Results</h3>
        {!isLoading ? (
          <Table striped bordered condensed hover>
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>LTI Advantage ID</th>
                <th>MyEducator Score</th>
                <th>LMS Posted Score</th>
                <th>LMS Max Score</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {currentState.lineItemResults &&
                currentState.lineItemResults.map((result, i) => (
                  <tr key={i}>
                    <td>
                      {result.lastName}, {result.firstName}
                    </td>
                    <td>{result.email}</td>
                    <td>{result.advantageId}</td>
                    <td>{result.myEdGradePoints}</td>
                    <td
                      style={
                        result.missingInLms ? missingGradeStyle : undefined
                      }
                    >
                      {result.result.resultScore}
                    </td>
                    <td
                      style={
                        result.missingInLms ? missingGradeStyle : undefined
                      }
                    >
                      {result.result.resultMaximum}
                    </td>
                    <td className="text-center">
                      <button
                        className="btn btn-sm btn-sm-myed btn-primary"
                        onClick={() => {
                          postSingleScore(
                            match.params.resourceLinkId,
                            result.userId
                          )
                        }}
                      >
                        POST SCORE
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>
        ) : (
          <div>
            <div className="d-flex justify-content-center">
              <p>Pulling Line Item Results info from LMS...</p>
            </div>
            <div className="d-flex justify-content-center">
              <LoadingSpinner
                style={{ fontSize: '10em', color: '#004876' }}
                outerClass={'block'}
              />
            </div>
          </div>
        )}
      </div>

      <div className="card-myed">
        {!isWaiting && (
          <button
            className="btn btn-sm btn-sm-myed btn-primary post-scores-button-left-align"
            onClick={postScores}
          >
            POST SCORES
          </button>
        )}
        <h3>Bulk Post Scores Results</h3>
        {!isWaiting ? (
          <div>
            <div>
              <Table striped bordered condensed hover>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Submission ID</th>
                    <th>Points</th>
                    <th>Status Code</th>
                    <th>Response Text</th>
                  </tr>
                </thead>
                <tbody>
                  {responses.length > 0 &&
                    responses.map((resp, idx) => (
                      <tr key={`resp-${idx}`}>
                        <td>{resp.user.fullName}</td>
                        <td>{resp.user.email}</td>
                        <td>{resp.submission.id}</td>
                        <td>{resp.submission.points}</td>
                        <td>{resp.resp.statusCode}</td>
                        <td>{resp.resp.text}</td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            </div>
          </div>
        ) : (
          <div>
            <div className="d-flex justify-content-center">
              <p>Posting scores to the LMS...</p>
            </div>
            <div className="d-flex justify-content-center">
              <LoadingSpinner
                style={{ fontSize: '10em', color: '#004876' }}
                outerClass={'block'}
              />
            </div>
          </div>
        )}
      </div>
      <GradeLogListView
        queryParams={{ resource_link_id: match.params.resourceLinkId }}
      />
    </React.Fragment>
  )
}

const copyToClipboard = async textToCopy => {
  try {
    await navigator.clipboard.writeText(textToCopy)
    ButterToast.raise({
      content: (
        <Cinnamon.Crisp
          title={'COPIED!'}
          content={`Copied "${textToCopy}" to your clipboard!`}
          scheme={Cinnamon.Crisp.SCHEME_BLUE}
          icon={<i className="far fa-copy fa-3x" />}
        />
      ),
    })
  } catch (err) {
    ButterToast.raise({
      content: (
        <Cinnamon.Crisp
          title={'An Error Occurred Copying Text'}
          content={`An error precluded the text from being copied: ${err}`}
          scheme={Cinnamon.Crisp.SCHEME_RED}
          icon={<i className="far fa-thumbs-down fa-3x" />}
        />
      ),
    })
  }
}

const ResourceLinkInfo = ({ resourceLinkObj }) => {
  return (
    <div>
      <h4>Activity Information</h4>
      <p>Activity Title: {resourceLinkObj.activity.title}</p>
      <p>
        Activity ID:{' '}
        <a
          onClick={() => {
            copyToClipboard(resourceLinkObj.activity.id)
          }}
        >
          {resourceLinkObj.activity.id}
          <i className="far fa-copy mr-2 color_teal fa-fw" />
        </a>
      </p>
      <p>
        Activity GUID:{' '}
        <a
          onClick={() => {
            copyToClipboard(resourceLinkObj.activity.guid)
          }}
        >
          {resourceLinkObj.activity.guid}
          <i className="far fa-copy mr-2 color_teal fa-fw" />
        </a>
      </p>
      <p>
        <a
          href={`/instructor/activity_information/${resourceLinkObj.course.coursenum}/${resourceLinkObj.activity.id}/`}
          target="_blank"
          rel="noopener noreferrer"
        >
          Setup Page{' '}
          <i className="far fa-external-link mr-2 color_teal fa-fw" />
        </a>
      </p>
      <p>
        <a
          href={`/instructor/activity_submissions/${resourceLinkObj.course.coursenum}/${resourceLinkObj.activity.id}/`}
          target="_blank"
          rel="noopener noreferrer"
        >
          Submissions Page{' '}
          <i className="far fa-external-link mr-2 color_teal fa-fw" />
        </a>
      </p>
      <p>
        <a
          href={`/instructor/activity_rules/${resourceLinkObj.course.coursenum}/${resourceLinkObj.activity.id}/`}
          target="_blank"
          rel="noopener noreferrer"
        >
          Rules Page{' '}
          <i className="far fa-external-link mr-2 color_teal fa-fw" />
        </a>
      </p>
      <hr />
      <h4>Resource Information </h4>
      <p>Resource Name: {resourceLinkObj.course.title}</p>
      <p>
        Coursenum:{' '}
        <a
          onClick={() => {
            copyToClipboard(resourceLinkObj.course.coursenum)
          }}
        >
          {resourceLinkObj.course.coursenum}
          <i className="far fa-copy mr-2 color_teal fa-fw" />
        </a>
      </p>
      <p>
        <a
          href={`/instructor/setup/${resourceLinkObj.course.coursenum}/`}
          target="_blank"
          rel="noopener noreferrer"
        >
          Settings Page{' '}
          <i className="far fa-external-link mr-2 color_teal fa-fw" />
        </a>
      </p>
      <p>
        <a
          href={`/instructor/admin_setup/${resourceLinkObj.course.coursenum}/`}
          target="_blank"
          rel="noopener noreferrer"
        >
          Admin Settings Page{' '}
          <i className="far fa-external-link mr-2 color_teal fa-fw" />
        </a>
      </p>
      <p>
        <a
          href={`/instructor/people/${resourceLinkObj.course.coursenum}/`}
          target="_blank"
          rel="noopener noreferrer"
        >
          People Page{' '}
          <i className="far fa-external-link mr-2 color_teal fa-fw" />
        </a>
      </p>
      <hr />
      <h4>Resource Link Information</h4>
      <p>
        Resource Link ID:{' '}
        <a
          onClick={() => {
            copyToClipboard(resourceLinkObj.id)
          }}
        >
          {resourceLinkObj.id}
          <i className="far fa-copy mr-2 color_teal fa-fw" />
        </a>
      </p>
      <p>
        Resource Link GUID:{' '}
        <a
          onClick={() => {
            copyToClipboard(resourceLinkObj.guid)
          }}
        >
          {resourceLinkObj.guid}
          <i className="far fa-copy mr-2 color_teal fa-fw" />
        </a>
      </p>
    </div>
  )
}

const ActivityPageTitle = ({ resourceLinkObj }) => {
  return (
    <div>
      <h2>{resourceLinkObj.activity.title} </h2>
    </div>
  )
}
